import { useEffect, useState } from "react";
import { useAuthStore } from "../store/useAuthStore";

export const useCommunityId = () => {
  const creator = useAuthStore(state => state.creator);
  const [communityId, setCommunityId] = useState(creator?.community?.id || null);

    useEffect(() => {
        setCommunityId(creator?.community?.id || null);
    }, [creator]);

    return communityId;
};
